import { render, staticRenderFns } from "./ProfileSecurity.vue?vue&type=template&id=acd3b8e6&scoped=true&"
import script from "./ProfileSecurity.vue?vue&type=script&lang=ts&"
export * from "./ProfileSecurity.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSecurity.vue?vue&type=style&index=0&id=acd3b8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd3b8e6",
  null
  
)

export default component.exports